// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e6c68141","732":"827ae031","977":"ec85007f"}[chunkId] + ".chunk.js";
};